<template>
    <div class="text-center">
        <h2
            class="text-center"
            style="margin-bottom: 5px"
        >CHI DẪN PHÒNG {{ chosen_building | translateBuildingName }}</h2>
        <h4 class="text-center" style="margin-top: 0px;">Ngày {{ date | formatTimeVN}}</h4>
        <h3 style="margin-bottom: 5px">Chi tiền dẫn phòng {{ agent_id | translateAgentName }}</h3>
        <h3
            style="margin-top: 0"
        >Đề nghị chị Gấm chi {{ agent_id | translateAgentName }} số tiền: {{ total_commission_amount | formatNumber }} đ</h3>
        <table class="table-border mx-auto">
            <thead>
                <tr>
                    <th>STT</th>
                    <th>SỐ PHÒNG</th>
                    <th>NGÀY DẪN</th>
                    <th>SỐ TIỀN</th>
                    <th>NGƯỜI DẪN</th>
                    <th>MÃ PHIẾU CỌC</th>
                    <th>NHẬN PHÒNG</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(receipt, index) in unpaid_commissions" :key="index">
                    <td>{{ index + 1}}</td>
                    <td>{{ receipt.room_id }}</td>
                    <td>{{ receipt.date_deposit | formatTimeServer}}</td>
                    <td>{{ receipt.amount | formatNumber}}</td>
                    <td>{{ receipt.agent_id | translateAgentName }}</td>
                    <td>{{ receipt.receipt_id }}</td>
                    <td>{{ receipt.status_text }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { roomByBuilding, translateBuildingName } from "Helpers";
export default {
    name: "print-tien-dan-phong",
    props: {
        items: Array,
        chosen_building: String,
        agent_id: Number
    },
    data() {
        return {};
    },
    computed: {
        unpaid_commissions() {
            return this.items.filter(commission => !commission.is_paid && commission.receipt_status != 1); // Chưa chi + Hủy cọc hoặc đã nhận phòng
        },
        total_commission_amount() {
            return this.unpaid_commissions.reduce(
                (acc, commission) => (acc += commission.amount),
                0
            );
        },
        date() {
            return new Date().toISOString().substring(0, 10);
        }
    }
};
</script>

<style>
</style>